import type { TypedDocumentNode } from "@graphql-typed-document-node/core";

import { graphql } from "@repo/graphql-types";
import { typedQueryFn } from "@/hooks/use-graphql";
import type { AuthenticationClient } from "@/lib/auth/authentication-client";

const AuthusMigrateSessionMutation = graphql(/* GraphQL */ `
  mutation AuthusMigrateSession($sessionToken: String!) {
    AuthusMigrateSession(arg1: { sessionToken: $sessionToken }) {
      sessionToken
      sessionJwt
      userId
    }
  }
`) as TypedDocumentNode<
  { AuthusMigrateSession: MigrateSessionResult },
  { sessionToken: string }
>;

interface MigrateSessionResult {
  sessionToken: string;
  sessionJwt: string;
  userId: string;
}

export async function migrateSession(
  auth0Token: string,
  authClient: AuthenticationClient,
): Promise<MigrateSessionResult> {
  const result = await typedQueryFn(AuthusMigrateSessionMutation, authClient, {
    sessionToken: auth0Token,
  });

  return result.AuthusMigrateSession;
}
